/**
 * @generated SignedSource<<7667f9146a15cf1352c8dcb44cd2b145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SiteFilterButton_Query$variables = {};
export type SiteFilterButton_QueryVariables = SiteFilterButton_Query$variables;
export type SiteFilterButton_Query$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
};
export type SiteFilterButton_QueryResponse = SiteFilterButton_Query$data;
export type SiteFilterButton_Query = {
  variables: SiteFilterButton_QueryVariables;
  response: SiteFilterButton_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceConnection",
    "kind": "LinkedField",
    "name": "sources",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SiteFilterButton_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SiteFilterButton_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "181f78a3680fa10ac1ea194dd048cab8",
    "id": null,
    "metadata": {},
    "name": "SiteFilterButton_Query",
    "operationKind": "query",
    "text": "query SiteFilterButton_Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2410525afeffca5f24df21acdb860020";

export default node;
